"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.icon = void 0;

const icon = ({
  cssProps: {
    expand
  }
}) => ({
  transform: "rotate(".concat(expand ? 180 : 0, "deg)"),
  transition: 'transform 0.3s ease'
});

exports.icon = icon;
//# sourceMappingURL=ExpansionPanel.style.js.map